import type { ChangeKind } from './parseChangelog';

/** Every sentence on the About page and its three entry points. */
export const ABOUT_COPY = {
  title: 'About Teamlane',
  version: (version: string) => `Version ${version}`,
  build: (commit: string) => `Build ${commit}`,
  developmentBuild: 'Development build',
  builtOn: (date: string) => `Built ${date}`,

  whatsNew: "What's new",
  whatsNewIn: "What's new in",
  latest: 'Latest',
  earlierReleases: 'Earlier releases',
  kinds: { new: 'New', improved: 'Improved', fixed: 'Fixed', other: 'Other changes' } satisfies Record<
    ChangeKind,
    string
  >,
  count: (n: number, kind: ChangeKind) =>
    kind === 'other' ? `${n} other` : `${n} ${kind}`,
  showAll: 'Show all releases',
  showFewer: 'Show fewer',
  noReleaseNotes: 'No release notes yet',

  licenceHeading: 'Licence',
  licence: 'Proprietary software. © 2025–present Fraction3 Ltd. All rights reserved.',
  supportPrompt: 'Questions?',
  contactSupport: 'Contact support',

  menuItem: 'About Teamlane',
  sheetRow: 'About',
  sidebarCaption: 'About',
} as const;
